// @flow

export default ({ format, value }) => {
  if (format === 'germannumber') {
    return parseFloat(value).toLocaleString('de-DE', { style: 'decimal' });
  }
  return value;
};
